<template>
  <div class="event-banner-container">
    <div
      v-for="event in eventBannerList"
      :key="event.eventid"
      class="event-banner"
      :style="{
        background: `linear-gradient(to right, ${event?.bgcolor?.left}, ${event?.bgcolor?.right})`,
      }"
    >
      <div class="banner-type">
        <a
          @click.prevent="goToEventDetailPage(event)"
          href="javascript:void(0)"
          :title="`${event.eventtitle} 상세로 이동`"
        >
          <img
            :src="getEventImage(event.bannerimage)"
            :alt="event.eventtitle"
          />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
  import { resizeThumbnail } from '@/common/utils/image'

  export default {
    name: 'EventBanner',
    props: {
      eventBannerList: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      getEventImage(img) {
        if (img) {
          return resizeThumbnail(img, {
            width: 0,
            height: 0,
            option: 20,
            quality: 80,
          })
        }
        return ''
      },
      goToEventDetailPage(event = {}) {
        const eventId = event?.eventid ?? ''

        this.$router.push({
          name: 'event_view',
          query: {
            eventId: eventId,
          },
        })
      },
    },
  }
</script>
<style scoped>
  .event-banner-container {
    position: relative;
    z-index: 30;
  }
  .event-banner {
    margin: 40px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    & + .event-banner {
      padding: 0;
    }
    img {
      width: 1240px;
    }
  }
</style>
